<template>
  <el-dialog
    :close-on-click-modal="false"
    title="地图"
    :lock-scroll="true"
    :visible.sync="dialogVisible"
    width="1000px"
  >
    <section class="mapContent posire" :class="{ hadKeywordList: listVisible }">
      <baidu-map
        class="map"
        :scroll-wheel-zoom="true"
        :center="center"
        :zoom="zoom"
        @ready="renderMap"
        @click="handleMapClick"
      >
        <bm-view class="map" />
        <bm-control :offset="{ width: '10px', height: '10px' }">
          <bm-auto-complete v-model="searchAddr" :sugStyle="{ zIndex: 1 }">
            <section class="searchMapInputBox">
              <el-input
                class="searchInput"
                v-model="searchAddr"
                placeholder="请输入"
                @keyup="getAddress"
              />
            </section>
          </bm-auto-complete>
        </bm-control>
        <bm-local-search
          class="searchList"
          :keyword="searchAddr"
          :auto-viewport="true"
          @searchcomplete="searchcomplete"
          @infohtmlset="infohtmlset"
        />

        <bm-geolocation
          anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
          :showAddressBar="true"
          :autoLocation="true"
        />
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
        <bm-marker
          v-if="markerPointAddress"
          :position="markerPoint"
          :dragging="true"
        >
          <bm-label
            :content="markerPointAddress"
            :labelStyle="{
              color: '#333',
              fontSize: '14px',
              borderColor: '#e0e0e0',
              padding: '0 16px',
            }"
            :offset="{ width: -35, height: 30 }"
          />
        </bm-marker>
      </baidu-map>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="sub">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      // 搜索结果数组
      searchResultList: [],
      currentSelectTitle: '',
      listVisible: false,
      searchTimer: null,
      searchAddr: '',
      BMap: null,
      map: null,
      dialogVisible: false,
      center: { lng: 0, lat: 0 },
      zoom: 3,
      pointDescVisible: false,
      markerPoint: null,
      markerPointAddress: '',
      // 下面是订单录入需要用到的参数
      markerPointAddressDetail: null,
    };
  },
  methods: {
    // 点击 panel
    infohtmlset (data) {
      this.currentSelectTitle = data.title;
      this.handleMapClick(data);
    },
    // 搜索完成
    searchcomplete (result) {
      if (!(result && result.Hr && result.Hr.length)) {
        this.listVisible = false;
        return;
      }
      this.listVisible = true;
      // 保存搜索出来的地址
      this.searchResultList = result.Hr;
      this.currentSelectTitle = result.Hr[0].title;
      this.handleMapClick(result.Hr[0]);
    },
    renderMap ({ BMap, map }) {
      this.BMap = BMap;
      this.map = map;
      this.markerPoint = this.center;
      this.center.lng = 116.404;
      this.center.lat = 39.915;
      this.zoom = 15;
    },
    show (data) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (data) {
          this.center = data.point;
          this.markerPoint = data.point;
          this.handleMapClick();
        } else {
          this.pointDescVisible = false;
          this.markerPoint = null;
          this.markerPointAddress = '';
          this.markerPointAddressDetail = null;
          this.currentSelectTitle = '';
        }
      });
    },
    // 获取备用地址（因为有的在地图上选择的地址会缺失很多信息，例如缺失道路和街道号，这时候可以用搜索出来的更详细的数据替换上）
    getBackupAddress (point) {
      let backupAddress = '';
      for (let item of this.searchResultList) {
        if (item.point) {
          if (item.point.lat === point.lat && item.point.lng === point.lng) {
            // 如果有详细地址返回
            if (item.address && item.address) {
              backupAddress = item.address;
              // 看看详细地址里面有没有包括市和省，如果没有就在前面加上
              if (!backupAddress.includes(item.city)) {
                backupAddress = item.city + backupAddress;
              }
              if (!backupAddress.includes(item.province)) {
                backupAddress = item.province + backupAddress;
              }
            }
          }
        }
      }
      return backupAddress;
    },
    getAddress (point = this.markerPoint) {
      const geoc = new this.BMap.Geocoder();
      const pt = new this.BMap.Point(point.lng, point.lat);
      geoc.getLocation(pt, (rs) => {
        const addComp = rs.addressComponents || {};
        const markerPointAddress = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber;
        addComp.city = addComp.city == '' ? addComp.district : addComp.city;
        const markerPointAddressDetail = {
          province: addComp.province || '',
          city: addComp.city || '',
          district: addComp.district || '',
          street: addComp.street || '',
          streetNumber: addComp.streetNumber || '',
          title: this.currentSelectTitle || '',
        };
        this.markerPointAddressDetail = markerPointAddressDetail;
        this.markerPointAddress = markerPointAddress;

        const backupAddress = this.getBackupAddress(point);
        // 如果 备用地址 比 地图上的地址详细，则使用备用地址（注：理论上来说是越长越详细）
        if (
          backupAddress.includes(markerPointAddressDetail.province) &&
          backupAddress.includes(markerPointAddressDetail.city) &&
          backupAddress.includes(markerPointAddressDetail.district) &&
          backupAddress.includes(markerPointAddressDetail.street) &&
          backupAddress.includes(markerPointAddressDetail.streetNumber &&
            backupAddress.length > markerPointAddress.length
          )
        ) {
          this.markerPointAddress = backupAddress;
        }
        this.pointDescVisible = true;
      });
    },
    // e 是 经纬度
    handleMapClick (e) {
      if (e && e.point) {
        this.markerPoint = e.point;
        this.getAddress();
      }
    },
    sub () {
      this.$emit('sub', {
        point: this.markerPoint,
        address: this.markerPointAddress,
        addressDetail: this.markerPointAddressDetail,
      });
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.searchList {
  width: 240px;
  position: absolute;
  top: 55px;
  left: 20px;
}
.searchMapInputBox {
  padding: 20px;
  .searchInput {
    width: 400px;
    margin-right: 16px;
  }
}
.mapContent {
  padding-bottom: 32px;
  .map {
    width: 100%;
    height: 500px;
  }
  .searchList {
    ::v-deep ol {
      height: 474px;
      overflow-y: auto;
    }
  }
}
.hadKeywordList {
  padding-left: 264px;
}
</style>
